import { render, staticRenderFns } from "./FlorestasPublicas.vue?vue&type=template&id=33ad647b&lang=pug"
import script from "./FlorestasPublicas.vue?vue&type=script&lang=js"
export * from "./FlorestasPublicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports